// ** React Imports
import { Fragment, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
// ** Custom Components
import NavbarUser from "./NavbarUser";
import AssistiveSelect from "@src/@core/components/assistive-select/AssistiveSelect";

import { ChevronDown } from "react-feather";
// ** Third Party Components
import { Menu, ArrowRight } from "react-feather";

// ** Reactstrap Imports
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { handleSetActiveDomain } from "@src/redux/reducers/userAccount";

const ThemeNavbar = (props) => {
  const { t } = useTranslation();
  // ** Props
  // Recebendo as props de controle do menu para sabermos quando ele está encolhido e podermos expandir
  const { skin, setSkin, setMenuVisibility, menuCollapsed, setMenuCollapsed } = props;
  void skin; void setSkin;
  const location = useLocation();
  const dispatch = useDispatch();

  const pathParts = location.pathname.split('/');
  const isDashboard = pathParts.includes('dashboard');
  // Rotas contextualizadas por domínio no /ai-content/*  (ex: /ai-content/alternative-texts)
  const isAiContentAlt = pathParts[1] === 'ai-content' && pathParts[2] === 'alternative-texts';
  const showDomainBreadcrumb = isDashboard || isAiContentAlt;

  const sites = useSelector((state) => state.userAccount.sites);
  const activeDomain = useSelector((state) => state.userAccount.activeDomain);

  const siteOptions = useMemo(
    () => (sites || []).map((s) => ({ value: s.domain, label: s.domain })),
    [sites]
  );

  const displayDomain = activeDomain || null;

  return (
    <Fragment>
      <div className="navbar-left-wrapper">
        {/* BOTÃO HAMBÚRGUER (Aparece apenas em telas menores que 1200px graças à classe d-xl-none) */}
        <div
          className="d-xl-none cursor-pointer"
          onClick={() => setMenuVisibility(true)}
          style={{ color: '#000000ff', margin: "0 8px" }} // Ajuste a cor se necessário para combinar com seu layout
        >
          <Menu size={24} />
        </div>

        {/* NOVA SETA PARA DIREITA (Desktop - Só aparece se o menu estiver recolhido) */}
        {menuCollapsed && (
          <button
            type="button"
            className="d-none d-xl-flex cursor-pointer align-items-center button-toggle-menu"
            onClick={() => setMenuCollapsed(false)}
            aria-label={t('navbar.expandMenu')}
            aria-expanded="false"
            title={t('navbar.expandMenu')}
            style={{
              color: '#000000ff',
              margin: "0 8px",
              background: "transparent",
              border: "none",
              padding: 0,
              borderRadius: "12px",
            }}
          >
            <ArrowRight size={20} aria-hidden="true" />
          </button>
        )}

        {/* BREADCRUMB */}
        <div className={`navbar-left ${showDomainBreadcrumb ? 'is-dashboard' : ''}`}>

          {showDomainBreadcrumb ? (
            <div className="breadcrumb-home" style={{ cursor: 'default' }}>
              <h1 className="breadcrumb-home-text text-gray">
                {t('navbar.homePage')}
              </h1>
            </div>
          ) : (
            <Link to="/dashboard" className="breadcrumb-home ho-ver">
              <h1 className="breadcrumb-home-text text-black">
                {t('navbar.homePage')}
              </h1>
            </Link>
          )}
          {showDomainBreadcrumb && (
            sites && sites.length === 0 ? (
              <>
                <span className="breadcrumb-divider-text">/</span>
                <span className="breadcrumb-site breadcrumb-site-disabled">
                  <div className="breadcrumb-site-text">
                    <span>{t('navbar.noDomain')}</span>
                  </div>
                </span>
              </>
            ) : displayDomain ? (
              <>
                <span className="breadcrumb-divider-text">/</span>

                <AssistiveSelect
                  value={displayDomain}
                  onChange={(v) => dispatch(handleSetActiveDomain(v))}
                  options={siteOptions}
                  searchable
                  toggleVariant="breadcrumb"
                  toggleContent={
                    <div className="breadcrumb-site">
                      <div className="breadcrumb-site-text">
                        <span>{displayDomain}</span>
                      </div>
                      <div className="breadcrumb-icon-button">
                        <ChevronDown size={16} />
                      </div>
                    </div>
                  }
                  searchPlaceholder={t("navbar.siteSearchPlaceholder")}
                  emptyText={t("navbar.siteSearchNoResults")}
                  maxHeight={400}
                  inNavbar
                />
              </>
            ) : null
          )}
        </div>
      </div>

      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  );
};

export default ThemeNavbar;
